(function(angular) {
    'use strict';

    angular.module('onvio.reports').factory('onvio.reports.onvioUsageService', onvioUsageService);
    onvioUsageService.$inject = ['$http', '$q', 'AuthenticatedSessionData', '$translate'];

    function onvioUsageService($http, $q, sessionData, $translate) {

        var factory = {
            loadReport: loadReport,
            loadTerms: loadTerms,
            loadLoginHistoryDetail: loadLoginHistoryDetail,
            getTranslations: getTranslations
        };

        var api = '/api/profiles/v1/usage-reports/companies/';
        var termsApi = '/api/profiles/v1/companies/';
        var auditEventsApi = '/api/audit-events/v1/events/services/PermissionServices?verb=PERMISSION_GROUP_UPDATE&itemsPerPage=1000';
        var canceler = $q.defer();
        var loadedCompanyId;
        return factory;

        function loadReport(report, startDate, endDate) {
            var url = '';
            canceler.resolve('cancelled');
            canceler = $q.defer();
            return getCompanyId().then(function(companyId) {
                if( report === 'audit-events') {
                    return loadAuditEvents(startDate, endDate);
                } else if (report === 'login-histories') {
                    url = api + companyId + '/last-logins' + '?startDate=' + startDate + '&endDate=' + endDate;
                } else if (report === 'registration-status') {
                    url = '/api/profiles/v2/usage-reports/companies/' + companyId + '/registration-status';
                } else {
                    url = api + companyId + '/' + report;
                }
                var opts = {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                };

                return $http({
                    method: 'GET',
                    url: url,
                    headers: opts,
                    timeout: canceler.promise
                });
            });
        }
        function loadAuditEvents(startDate, endDate) {
            startDate = moment(startDate).format(); // jshint ignore:line
            endDate = moment(endDate).endOf('day').format();; // jshint ignore:line
            var url = auditEventsApi + '&fromDateTime=' + startDate + '&toDateTime=' + endDate;
            return $http({
                method: 'GET',
                url: url
            });
        }
        function loadTerms(eulaId) {
            return getCompanyId().then(function(companyId) {
                var url = termsApi + companyId + '/terms/' + eulaId;
                var opts = {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                };

                return $http({
                    method: 'GET',
                    url: url,
                    headers: opts
                });
            });
        }
        function loadLoginHistoryDetail(contactId, startDate, endDate) {
            return getCompanyId().then(function(companyId) {
                var url = api + companyId + '/contacts/' + contactId + '/login-histories';
                if(startDate && endDate) {
                    url = url + '?startDate=' + startDate + '&endDate=' + endDate;
                }
                var opts = {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                };
                return $http({
                    method: 'GET',
                    url: url,
                    headers: opts
                });
            });
        }
        function getTranslations(){
            var promises = [
                $translate('Bluemoon.Practice.Common.Actions.Export'),
                $translate('Reports.OnvioUsage.ActiveUserSessions'),
                $translate('Reports.OnvioUsage.LoginHistory'),
                $translate('Reports.OnvioUsage.TermsAndConditions'),
                $translate('Reports.OnvioUsage.RegistrationStatus'),
                /*Column Headers*/
                $translate('Reports.OnvioUsage.ColumnHeader.Login'),
                $translate('Reports.OnvioUsage.ColumnHeader.FullName'),
                $translate('Reports.OnvioUsage.ColumnHeader.LoginTime'),
                $translate('Reports.OnvioUsage.ColumnHeader.IpAddress'),
                $translate('Reports.OnvioUsage.ColumnHeader.Version'),
                $translate('Reports.OnvioUsage.ColumnHeader.AcceptedDate'),
                $translate('Reports.OnvioUsage.ShowHideColumns'),
                $translate('Reports.OnvioUsage.LastLogin'),
                $translate('Bluemoon.Practice.Common.Actions'),
                $translate('Reports.OnvioUsage.LoginHistory.Tooltip'),
                $translate('Reports.OnvioUsage.ShowHideFilters'),
                $translate('Reports.OnvioUsage.PermGroupHistory'),
                $translate('Reports.OnvioUsage.ColumnHeader.PermGroupChange'),
                $translate('Reports.OnvioUsage.ColumnHeader.PermGroup'),
                $translate('Reports.OnvioUsage.ColumnHeader.ChangedByHeader'),
                $translate('Reports.OnvioUsage.ColumnHeader.Date'),
                $translate('Bluemoon.Core.Setup.Groups.MembersIdLabel'),
                $translate('Core.Captions.ContactEmail.EmailType'),
                $translate('Reports.OnvioUsage.Email'),
                $translate('Reports.OnvioUsage.RegistrationSent'),
                $translate('Reports.OnvioUsage.RegistrationDate'),
                $translate('Core.Captions.Activity.Status'),
                $translate('Reports.OnvioUsage.Pending'),
                $translate('Reports.OnvioUsage.UserStatus.Active'),
                $translate('Reports.OnvioUsage.UserStatus.Inactive'),
                $translate('Reports.OnvioUsage.UserType.Standalone'),
                $translate('Reports.OnvioUsage.UserType.Staff'),
                $translate('Reports.OnvioUsage.UserType.Client'),
            ];
            return $q.all(promises).then(function(translations){
                return translations;
            }, function(error){
                console.log(error);
            });
        }

        function getCompanyId() {
            var deferred = $q.defer();

            if(angular.isDefined(loadedCompanyId)){
                deferred.resolve(loadedCompanyId);
                return deferred.promise;
            }

            if(angular.isDefined(sessionData.bindings) && angular.isDefined(sessionData.bindings.ApplicationConfiguration) && angular.isDefined(sessionData.bindings.ApplicationConfiguration.CompanyId)){
                loadedCompanyId = sessionData.bindings.ApplicationConfiguration.CompanyId;
                deferred.resolve(loadedCompanyId);
                return deferred.promise;
            }

            return sessionData.getBindings().then(function(bindings){
                loadedCompanyId = bindings.ApplicationConfiguration.CompanyId;
                return loadedCompanyId;
            });
        }
    }

})(window.angular);
